import React from 'react'

const React_Coding_Practice_32 = () => {
  return (
    <div>
      <h1>Coding Pratice 32</h1>
    </div>
  )
}

export default React_Coding_Practice_32
